import React from "react";
import { Banknote } from "lucide-react"; // Lucide Icon
import "./index.css";

export default function BankDetails() {
  const bankData = [
    {
      title: "ORBIT SECURITIES (PVT) LTD",
      iban: "PK49JSBL9005000002043302",
      bank: "JS BANK LIMITED",
      branch: "PSX BRANCH-9005",
      city: "Karachi",
    },
    {
      title: "ORBIT SECURITIES (PVT) LTD",
      iban: "PK64 MEZN 0099 0901 0725 0749",
      bank: "MEEZAN BANK LIMITED",
      branch: "PSX BRANCH-9909",
      city: "Karachi",
    },
    {
      title: "ORBIT SECURITIES (PVT) LTD",
      iban: "PK85 BAHL 1012 0081 0077 5501",
      bank: "BANK AL HABIB LIMITED",
      branch: "PSX BRANCH",
      city: "Karachi",
    },
    {
      title: "ORBIT SECURITIES (PVT) LTD",
      iban: "PKDUIB0000000822930002",
      bank: "DUBAI ISLAMIC BANK",
      branch: "PSX BRANCH",
      city: "Karachi",
    },

    {
      title: "ORBIT SECURITIES (PVT) LTD",
      iban: "PK11BKIP0101000208420002",
      bank: "BANK ISLAMI PAKISTAN LIMITED",
      branch: "PSX BRANCH-0101",
      city: "Karachi",
    },
    {
      title: "ORBIT SECURITIES (PVT) LTD",
      iban: "PK60UNIL0109000344921524",
      bank: "UNITED BANK LIMITED",
      branch: "PSX BRANCH-0109",
      city: "Karachi",
    },
  ];

  return (
    <div className="bank-details-container">
      <h1 className="bank-details-title">BANK DETAILS</h1>
      <h2 className="bank-details-subtitle">
        BANK ACCOUNTS DETAILS FOR CLIENT FUND DEPOSIT
      </h2>

      <div className="bank-details-table-wrapper">
        <table className="bank-details-table">
          <thead>
            <tr>
              <th>Title of Account</th>
              <th>IBAN</th>
              <th>Name of Bank</th>
              <th>Branch</th>
              <th>City</th>
            </tr>
          </thead>
          <tbody>
            {bankData.map((bank, index) => (
              <tr key={index}>
                <td>{bank.title}</td>
                <td className="iban">{bank.iban}</td>
                <td>{bank.bank}</td>
                <td>{bank.branch}</td>
                <td>{bank.city}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
